'use client'
import { useTranslations } from 'next-intl'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'
import { LFS_URL } from '@repo/web-utils/env'

import { HasAllAccess } from './has-all-access'

export function HeaderNonAllAccess() {
  const { data: hasAllAccessData, isPending: hasAllAccessLoading } = useHasAllAccessQuery()

  const t = useTranslations('pages.subscription.hero')

  //TODO: Replace it with useProductCountsQuery data once we move to server side rendering
  //Represents the sum of embroidery, fonts, crafts, and graphics
  const value = 11_739_162

  if (hasAllAccessData && !hasAllAccessLoading) {
    return null
  }

  return (
    <section className="pb-[70px]">
      <HasAllAccess>
        <div
          style={{
            backgroundImage: `url(${LFS_URL}/web/pages/subscription/Banner_subscription.png)`,
          }}
          className="text-primary-700 text-16 relative mx-auto flex max-w-[800px] flex-col items-center justify-center gap-5 bg-[length:1100px_70%] bg-center bg-no-repeat pt-10 text-center"
        >
          <p className="font-bold">{t('title')}</p>
          <h1 className="text-36 text-center font-bold leading-10">
            {t.rich('header', {
              br: () => <br />,
            })}
          </h1>
          <span className="inline text-center" suppressHydrationWarning>
            {t.rich('copy', {
              br: () => <br />,
              number: () => value.toLocaleString(),
            })}
          </span>
        </div>
      </HasAllAccess>
    </section>
  )
}
